import { AfterViewInit, Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hub-text-area',
  templateUrl: './hub-text-area.component.html',
  styleUrls: ['./hub-text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HubTextAreaComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => HubTextAreaComponent),
      multi: true,
    },
  ],
})
export class HubTextAreaComponent implements ControlValueAccessor, AfterViewInit {
  @Input() label: string = '';
  @Input() placeholder: string = '';

  @Input() icon: string = '';
  @Input() iconColor?: string = '';
  @Input() isDisabled?: boolean = false
  @Input() autofocus?: boolean = false;
  @Input() rows?: number = 10;
  @Input() labelColor?: string = '';
  @Input() required?: boolean = false;
  @Input() autoGrow?: boolean = false;
  @Input() rounded: boolean = false;
  @Input() errorLabel?: string = this.translate.instant('general.error.field_is_required');

  @ViewChild('textareaRef', { static: false }) textareaRef!: ElementRef<HTMLTextAreaElement>;

  value: string | null = null;
  disabled = false;

  constructor(
    private translate: TranslateService
  ) { }

  ngAfterViewInit(): void {
    if (this.autofocus && this.textareaRef) {
      this.textareaRef.nativeElement.focus(); // Programmatically set focus
    }
  }

  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: string | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: FormControl): ValidationErrors | null {
    return control.errors;
  }

  handleInputChange(event: any) {
    this.value = event.target.value;
    this.onChange(this.value); // 🔥 This triggers ngModelChange
  }
}
